var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-shop-department.ee234993.png","uri@3x": __webpack_public_path__ + "icon-shop-department.4f35c395.png","uri@2x": __webpack_public_path__ + "icon-shop-department.61a2522e.png",
    width: 21,
    height: 19
});